import { Base } from '@wilson/base';
import { Role } from './role';

export enum FeatureName {
  Absence = 'absence',
  AbsenceManager = 'absence-manager',
  Administration = 'administration',
  AssignmentManager = 'assignment-manager',
  Billing = 'billing',
  Clara = 'clara',
  Client = 'client',
  Contract = 'contract',
  Equipment = 'equipment',
  EquipmentPlanning = 'equipment-planning',
  Integration = 'integration',
  Location = 'location',
  MobileShiftReporting = 'mobile-shift-reporting',
  OperationBoard = 'operation-board',
  OperativeReports = 'operative-reports',
  OrganizationalUnit = 'organizational-unit',
  Payroll = 'payroll',
  Preference = 'preference',
  Project = 'project',
  ProjectTimeline = 'project-timeline',
  Qualification = 'qualification',
  Role = 'role',
  Service = 'service',
  Shift = 'shift',
  ShiftDisposition = 'shift-disposition',
  ShiftPlan = 'shift-plan',
  StayManagement = 'stayManagement',
  User = 'user',
  Vehicle = 'vehicle',
  WilsonAI = 'wilson-ai',
  WilsonShare = 'wilson-share',
  WorkTimeManagement = 'work-time-management',
}

export enum RolePermissionSubject {
  Absence = 'absence',
  Agreement = 'Agreement',
  ExternalExtensionWorkflow = 'ExternalExtensionWorkflow',
  ActivityQualificationV2 = 'ActivityQualification',
  ActivityTemplate = 'ActivityTemplate',
  ActivityTemplateQualificationV2 = 'ActivityTemplateQualification',
  Administration = 'administration',
  BankAccount = 'BankAccount',
  Billing = 'billing',
  BillingSetting = 'BillingSetting',
  Client = 'Client',
  Contract = 'contract',
  EquipmentUnit = 'EquipmentUnit',
  GeneralSetting = 'GeneralSetting',
  GeoLocation = 'GeoLocation',
  Integration = 'integration',
  Invoice = 'Invoice',
  Label = 'Label',
  MobileShiftReporting = 'mobile-shift-reporting',
  OperationBoard = 'operation-board',
  OperativeReport = 'OperativeReport',
  OperativeReportCategorySetting = 'OperativeReportCategorySetting',
  OrganizationalUnit = 'organizational-unit',
  Payroll = 'payroll',
  PayrollTransaction = 'PayrollTransaction',
  Product = 'Product',
  Project = 'Project',
  Qualification = 'qualification', // v1
  QualificationProfile = 'QualificationProfile',
  QualificationV2 = 'Qualification',
  QualificationV2Category = 'QualificationCategory',
  Role = 'role',
  Route = 'Route',
  Service = 'service',
  ServiceDeviation = 'ServiceDeviation',
  ServiceTemplate = 'ServiceTemplate',
  SharedUser = 'SharedUser',
  Shift = 'shift',
  ShiftV2 = 'Shift',
  ShiftAttachment = 'ShiftAttachment',
  ShiftDisposition = 'shift-disposition',
  ShiftNote = 'ShiftNote',
  ShiftPlan = 'shift-plan',
  ShiftSeries = 'ShiftSeries',
  StaffSearchProfitabilitySetting = 'StaffSearchProfitabilitySetting',
  Stay = 'Stay',
  StayAttachment = 'StayAttachment',
  User = 'user',
  UserGeneralPreference = 'UserGeneralPreference',
  UserLocationPreference = 'UserLocationPreference',
  UserPayrollMonthlyClosure = 'UserPayrollMonthlyClosure',
  UserQualificationV2 = 'UserQualification',
  QualificationTraining = 'QualificationTraining',
  QualificationTrainingAttachment = 'QualificationTrainingAttachment',
  UserQualificationV2Attachment = 'UserQualificationAttachment',
  UserShiftTimePreference = 'UserShiftTimePreference',
  UserVehiclePreference = 'UserVehiclePreference',
  Vehicle = 'vehicle',
  WilsonAI = 'wilson-ai',
  WilsonShare = 'wilson-share',
  WorkTimeManagement = 'work-time-management',
  CirculationGroup = 'CirculationGroup',
  MobileWorkingTime = 'mobileWorkingTime',
}

export enum RoleAction {
  Create = 'create',
  Delete = 'delete',
  Read = 'read',
  ReadShared = 'read-shared',
  Update = 'update',
  Accept = 'accept',
}

export interface Permission extends Base {
  action: RoleAction;
  subject: FeatureName;
  fields: string | string[] | null;
  // eslint-disable-next-line
  conditions: any;

  rolePermissions: RolePermission[];
}

export interface RolePermission extends Base {
  role?: Role;
  roleId: Role['id'];
  permission?: Permission;
  permissionId: Permission['id'];
}

export interface Permissions {
  featurePermissions: string[];
  rolePermissions: Permission[];
}

// should only be consumed by route guards
export interface RolePermissionGuard {
  action: RoleAction;
  subject: RolePermissionSubject;
}

// should only be consumed by route guards
export interface AtLeastOneRolePermissionGuard {
  action: RoleAction;
  subjects: RolePermissionSubject[];
}
